<template>
  <v-row justify="center">
    <v-dialog v-model="open" width="872px" :fullscreen="isMobileBreakpoint">
      <v-card
        class="d-flex flex-column justify-space-between align-center pa-6"
        flat
        tile
        :height="!isMobileBreakpoint ? 537 : ''"
      >
        <div class="w-full d-flex justify-end">
          <v-btn icon @click="handleClose">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <div class="container-title mb-8">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="64"
            height="64"
            viewBox="0 0 64 64"
            fill="none"
          >
            <path
              d="M26.6666 53.3333C26.6664 53.8289 26.8042 54.3147 27.0647 54.7363C27.3252 55.1578 27.698 55.4985 28.1413 55.72L33.4746 58.3867C33.8813 58.5899 34.3331 58.6857 34.7873 58.6652C35.2414 58.6446 35.6827 58.5083 36.0693 58.2691C36.456 58.03 36.775 57.696 36.9963 57.2989C37.2175 56.9017 37.3335 56.4546 37.3333 56V37.3333C37.3339 36.0117 37.8252 34.7373 38.7119 33.7573L57.9733 12.4533C58.3185 12.0708 58.5455 11.5965 58.6269 11.0877C58.7082 10.5789 58.6404 10.0574 58.4317 9.58633C58.2229 9.11525 57.8822 8.71473 57.4506 8.4332C57.0191 8.15168 56.5152 8.00122 55.9999 8H7.99993C7.48422 8.00019 6.97962 8.14991 6.54727 8.43103C6.11491 8.71215 5.77335 9.11261 5.56395 9.5839C5.35455 10.0552 5.2863 10.5771 5.36747 11.0864C5.44863 11.5957 5.67574 12.0705 6.02127 12.4533L25.2879 33.7573C26.1747 34.7373 26.666 36.0117 26.6666 37.3333V53.3333Z"
              fill="url(#paint0_linear_6377_83123)"
            />
            <defs>
              <linearGradient
                id="paint0_linear_6377_83123"
                x1="5.33423"
                y1="33.334"
                x2="58.6603"
                y2="33.334"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#3F55EE" />
                <stop offset="1" stop-color="#8594FF" />
              </linearGradient>
            </defs>
          </svg>
          <h1
            class="body-bold-medium mt-6 text-center"
            style="white-space: pre-line"
          >
            {{ $t('message.pages.funnel.firstModal.title') }}
          </h1>
          <span
            class="body-regular-small mt-6 neutral-40-light--text text-center"
            style="white-space: pre-line"
            >{{ $t('message.pages.funnel.firstModal.description') }}
            <a
              type="primary"
              target="_blank"
              :href="$t('message.pages.funnel.firstModal.href')"
            >
              {{ $t('message.pages.funnel.firstModal.articleFunnel') }}
              <v-icon size="16" color="primary" class="ml-1"
                >mdi-open-in-new</v-icon
              >
            </a></span
          >
          <base-btn class="mt-6" @click="handleClose">{{
            $t('message.pages.funnel.firstModal.button')
          }}</base-btn>
        </div>
        <div></div>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
  name: 'FirstModal',
  components: {},
  data: () => ({
    open: false,
    isFetching: false,
    countVideos: 0,
    removingGroups: [],
    removingGroup: {
      name: '',
      id: '',
    },
    removeText: '',
    password: '',
    showPassword: false,
    permanentConfirm: false,
    passwordError: false,
    passwordErrorMessage: '',
    apiError: null,
  }),
  computed: {
    ...mapState('user', {
      isMobileBreakpoint: 'isMobileBreakpoint',
      isTabletBreakpoint: 'isTabletBreakpoint',
    }),
  },
  mounted() {
    this.$root.$on('openFirstModal', () => {
      this.hideCrispButton()
      this.open = true
    })
  },
  beforeDestroy() {
    this.$root.$off('removeMultipleModal')
    this.$root.$off('drmRemoveGroupModal')
    this.showCrispButton()
  },
  methods: {
    ...mapActions('session', ['signInUser']),
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),

    handleClose() {
      this.open = false
      this.removeText = ''
      this.password = ''
      this.permanentConfirm = false
      this.showPassword = false
      this.showCrispButton()
    },
    hideCrispButton() {
      const crispButton = document.querySelector('.crisp-client')
      if (crispButton && this.isMobileBreakpoint) {
        crispButton.style.setProperty('display', 'none', 'important')
      }
    },
    showCrispButton() {
      const crispButton = document.querySelector('.crisp-client')
      if (crispButton) {
        crispButton.style.removeProperty('display')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.w-full {
  width: 100%;
}
.container-title {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
::v-deep .v-toolbar {
  height: 90px !important;
}

::v-deep .v-toolbar__content {
  padding: 0 !important;
  align-items: flex-start !important;
}

.input::v-deep {
  label {
    left: -10px !important;
  }

  input::placeholder {
    font-size: 12px !important;
  }
}

::v-deep .v-input__append-inner {
  margin: auto !important;
}

.card-actions {
  border-top: 1px solid var(--v-neutral-95-lightest-base) !important;
}

.mobile-actions {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;

  .base-button {
    width: 50%;
  }
}
.container-card-options {
  display: flex;
  padding: 24px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  border-radius: 8px;
  width: 50%;
  background: varFigma(neutral-99);
}
</style>
